import { storageApi } from '~api';
import { LANGUAGE_EN, LANGUAGE_ES } from '~localize';

const getVimeoSrc = id => `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0&autoplay=1`;

export default async () => {
  await storageApi.addVideoToVariant(LANGUAGE_EN, getVimeoSrc('532263027'));
  await storageApi.addVideoToVariant(LANGUAGE_ES, getVimeoSrc('532313924'));
};
